/// <amd-module name="TFS/CreateProject/ActionsHub" />
import { Action } from "VSS/Reflux/Action";

import { IProjectCreationMetadata, StatusValueType } from "TFS/CreateProject/Contracts";
import { IStatusMessage } from "TFS/CreateProject/Models";

export interface IProjectCreationMetadataLoadedPayload {
    pageStatus: IStatusPayload;
    statusMessage: IStatusMessage;
    projectCreationMetadata?: IProjectCreationMetadata;
}

export interface IProjectCreationStatusPayload {
    projectName: string;
    navigationUrl: string;
    creationStatus: IStatusPayload;
    statusMessage: IStatusMessage;
    projectCreationOperationId?: string;
}

export interface IProjectNameValidationStatusPayload {
    projectName: string;
    status: IStatusPayload;
}

export interface IProjectLimitCheckStatusPayload {
    isBelowLimit: boolean;
    isBelowWarning: boolean;
    status: IStatusPayload;
}

export interface IStatusPayload {
    value: StatusValueType;
    message: string;
    detailedMessage?: string;
}

/**
 * A container for the current instances of the actions that can be triggered from the create project control
 */
export class ActionsHub {
    public projectCreationMetadataLoadStarted = new Action<IProjectCreationMetadataLoadedPayload>();
    public projectCreationMetadataLoadSucceeded = new Action<IProjectCreationMetadataLoadedPayload>();
    public projectCreationMetadataLoadFailed = new Action<IProjectCreationMetadataLoadedPayload>();
    public existingProjectNamesFetched = new Action<string[]>();

    // Project creation actions
    public projectCreationStarted = new Action<IProjectCreationStatusPayload>();
    public projectCreationSucceeded = new Action<IProjectCreationStatusPayload>();
    public projectCreationFailed = new Action<IProjectCreationStatusPayload>();

    // Project name validation actions
    public projectNameValidationSucceeded = new Action<IProjectNameValidationStatusPayload>();
    public projectNameValidationFailed = new Action<IProjectNameValidationStatusPayload>();
    public projectNameValidationReset = new Action<IProjectNameValidationStatusPayload>();

    // Project limit check actions
    public projectLimitCheckSucceeded = new Action<IProjectLimitCheckStatusPayload>();
    public projectLimitCheckFailed = new Action<IProjectLimitCheckStatusPayload>();

    // Project params changed actions
    public projectDescriptionChanged = new Action<string>();
    public versionControlChanged = new Action<string>();
    public projectVisibilityChanged = new Action<number>();
    public processTemplateChanged = new Action<string>();

    // Status message dismissed action
    public statusMessageDismissed = new Action<void>();

    // Advanced options action
    public advancedOptionVisibilityToggled = new Action<void>();
}
